import { ESocketEvents } from '@lbs/shared-rp-types'
import { observer } from 'mobx-react-lite'
import { useSocketContext } from 'pages/ManageGameRussianPoker/providers/SocketProvider'
import { useRussianPokerStore } from 'pages/ManageGameRussianPoker/useRussianPokerStore'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { RpDealerButton } from '../index'
import exitIcon from './img/exit.svg'
import filtersIcon from './img/filters.svg'
import { ButtonExitStartScreen, ButtonFilters, Container, Middle, Top } from './styles'

const RPDealerStartWindow: FC = observer(() => {
  const { emit } = useSocketContext()
  const navigate = useNavigate()
  const { gameId } = useRussianPokerStore()

  return (
    <Container>
      <Top>
        <ButtonFilters
          onClick={() => {
            // TODO: RP: filters
            console.log('filters')
          }}>
          <img src={filtersIcon} alt="filters" />
        </ButtonFilters>
      </Top>
      <Middle>
        <RpDealerButton
          bg="green"
          text="Начать игру"
          cb={() => {
            emit(ESocketEvents.START_GAME, gameId)
          }}
        />

        <ButtonExitStartScreen
          onClick={() => {
            navigate(-1)
          }}>
          <img src={exitIcon} alt="exit" />
        </ButtonExitStartScreen>
      </Middle>
    </Container>
  )
})

export default RPDealerStartWindow
